/**多語言配置說明 https://segmentfault.com/a/1190000014229902 */
//越南
export const lang ={
  Please_set_materialtype_in_product_page:"Quý khách vui lòng vào trang sản phẩm để sửa đổi và thiết lập loại nguyên liệu của từng sản phẩm - thành phẩm - bán thành phẩm - phụ kiện.",
  deleteAccount:"Đăng xuất",
  deleteAccountWillDeleteAllData:"Việc đăng xuất khỏi tài khoản sẽ xóa toàn bộ dữ liệu và khiến bạn không thể đăng nhập được.",
  backupDatabase:"sao lưu cơ sở dữ liệu",
  restoreDatabase:"Khôi phục cơ sở dữ liệu",
  materialtype:"Loại vật liệu",
  Manufacturing:"Phiên bản sản xuất",
  Professional:"Phiên bản chuyên nghiệp",
  Standard:"Phiên bản tiêu chuẩn",
  product:"Sản phẩm hoàn thiện",
  halfProduct:"Sản phẩm bán hoàn thiện",
  components:"Phụ kiện",
  Parent:"thành phần cha mẹ",
  Children:"Phụ kiện phụ",
  Level:"Hệ thống cấp bậc",
  Timing:"Thời gian",
  PieceCount:"sản phẩm",
  Wages:"Tiền lương",
  InternalProcess:"Quy trình nội bộ",
  ExternalProcess:"quá trình bên ngoài",
  ProceName:"Tên quy trình",
  ProceIndex:"Lệnh thực hiện",
  ChargeMan:"hiệu trưởng",
  BillMethod:"Phương thức thanh toán",
  ConsumTime:"giờ làm việc",
  Accessories:"Phụ kiện",
  Assembly:"Tập hợp",
  materials:"nguyên vật liệu",
  task:"Nhiệm vụ",
  process:"quá trình",
  BOM:"BOM",
  Production:"Sản xuất",
  RestorePurchaseOneUse:"Khôi phục giao dịch mua (một người dùng (giới hạn ở các giao dịch mua trước đó))",
  buy_fail_try_again:"Vui lòng click lại để mua hàng",
  Export:"Xuất khẩu",
  Date:"ngày",
  BankDetail:"thông tin chi tiết ngân hàng",
  Seller:"người bán",
  Buver:"người mua",
  Currency:"tiền tệ",
  CompanyName:"Tên công ty",
  ProformaInvoice:"hóa đơn chiếu lệ",
  Discount:"Giảm giá",
  PayStatus:"Tình trạng thanh toán",
  ShippingStatus:"Tình trạng giao hàng",
  FreightType:"Loại hình vận chuyển",
  Shipping:"vận chuyển hàng hóa",
  Payment:"Sự chi trả",
  Moneyname:"tên tiền tệ",
  Tax:"thuế",
  Freight:"Chi phí vận tải",
  Insurance:"bảo hiểm",
  Bankfee:"phí ngân hàng",
  Qc:"Chứng nhận chất lượng",
  Exchangerate:"tỷ giá",
  Shippingnumber:"số lô hàng",
  ShipDate:"Ngày xuất hàng",
  Arrivedate:"Ngày tới",
  Grossweight:"trọng lượng thô",
  CubicWeight:"trọng lượng khối",
  Totalpackages:"Tổng số gói",
  Moneytype:"loại tiền tệ",
  Quotedate:"Ngày trích dẫn",
  Validitydate:"Ngày hợp lệ",
  Paymentterm:"hết hạn trả lương",
  Priceterm:"thời hạn định giá",
  DeliveryTerm:"Thời gian giao hàng",
  BankName:"tên ngân hàng",
  BankAddress:"địa chỉ ngân hàng",
  SwiftCode:"Mã ngân hàng",
  Review:"Ôn tập",
  Signfor:"Ký nhận",
  Finance:"tài chính",
  Receiver:"Người nhận",
  Business:"việc kinh doanh",
  ContactPerson:"Người liên hệ",
  Profit:"lợi nhuận",
  Staff_must_use_in_browser_please_check_the_address_in_help_page:"Nhân viên phải sử dụng Google Chrome. Vui lòng kiểm tra địa chỉ IP trên trang trợ giúp của APP máy tính dịch vụ chính, sau đó nhập địa chỉ vào cột URL của các trình duyệt máy tính khác để mở thông tin đăng nhập",
  newPassword:"mật khẩu mới",
  ForgetPassword:"quên mật khẩu",
  ContactUs:"Liên hệ với chúng tôi/đưa ra đề xuất",
  Actualpay_should_big_then_shouldpay:"Khoản thu thực tế không thể lớn hơn khoản phải thu",
  ShopAddress:"Địa chỉ cửa hàng của tôi Quét mã QR để đặt hàng",
  Submit:"nộp",
  All:"tất cả",
  OrdernumExists:"Số đơn đặt hàng đã tồn tại",
  PermissionDenied:"sự cho phép bị từ chối",
  StockTransfer:"Chuyển nhượng chứng khoán",
  FromWarehouse:"Chuyển ra khỏi kho",
  ToWarehouse:"Chuyển về kho",
  PleaseUseInWebBrowser:"Vui lòng sử dụng chức năng xuất Excel trong Google Chrome",
  PleasePrintInWebBrowser:"Vui lòng sử dụng chức năng in trong Google Chrome",
  HistoryPrice:"giá lịch sử",
  SerialNumber:"số seri",
  Please_Use_In_APP:"Vui lòng sử dụng nó trong phần mềm máy tính",
  Please_Purchase_In_APP:"Vui lòng mua trong APP, không phải trong trình duyệt",
  Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Bạn có thể kết nối với cơ sở dữ liệu Postgresql. Dữ liệu của bạn sẽ được lưu trữ trong cơ sở dữ liệu Postgresql. Theo mặc định, bạn không cần kết nối với cơ sở dữ liệu Postgresql. Mặc định là cơ sở dữ liệu Sqlite cục bộ.",
  Connect_Postgresql_database_data_will_store_in_Postgresql:"Kết nối với cơ sở dữ liệu Postgresql, dữ liệu của bạn sẽ được lưu trữ trong cơ sở dữ liệu Postgresql và dữ liệu sẽ được đọc lại",
  Use_sqlite_data_will_store_in_local:"Sử dụng sqlite, dữ liệu sẽ được lưu trữ trên máy cục bộ",
  UsePostgresqlDatabase:"Sử dụng cơ sở dữ liệu PGSQL",
  UseSqliteDatabase:"Sử dụng cơ sở dữ liệu Sqlite",
  DatabaseName:"Cơ sở dữ liệu tên",
  Test_connect:"kiểm tra kết nối",
  If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Nếu sản phẩm có màu sắc, kích thước vui lòng điền số 0 cho kho ban đầu, sau khi thêm sản phẩm thì nhập kho trong giao dịch mua.",
  my:"của tôi",
  my_shop_qrcode_scan:"Mã QR của cửa hàng tôi cung cấp cho khách hàng khả năng quét mã để đặt hàng, điện thoại di động của khách hàng phải được kết nối với cùng một bộ định tuyến với máy tính của bạn.",
  ip:"IP",
  port:"Hải cảng",
  orderstatus:"Tình trạng đặt hàng",
  image:"hình ảnh",
  Template:"bản mẫu",
  Please_select_a_excel_file:"Vui lòng chọn một tập tin",
  Please_select_only_one_excel_file:"Chỉ có thể chọn một tập tin",
  Connect_Internet_Login_again:"Kết nối Internet và đăng nhập lại trước khi mua",
  Please_set_materialtype_in_product_page:"Quý khách vui lòng vào trang sản phẩm để sửa đổi và thiết lập loại nguyên liệu của từng sản phẩm - thành phẩm - bán thành phẩm - phụ kiện.",
  deleteAccount:"Đăng xuất",
  deleteAccountWillDeleteAllData:"Việc đăng xuất khỏi tài khoản sẽ xóa toàn bộ dữ liệu và khiến bạn không thể đăng nhập được.",
  backupDatabase:"sao lưu cơ sở dữ liệu",
  restoreDatabase:"Khôi phục cơ sở dữ liệu",
  materialtype:"Loại vật liệu",
  Manufacturing:"Phiên bản sản xuất",
  Professional:"Phiên bản chuyên nghiệp",
  Standard:"Phiên bản tiêu chuẩn",
  product:"Sản phẩm hoàn thiện",
  halfProduct:"Sản phẩm bán hoàn thiện",
  components:"Phụ kiện",
  Parent:"thành phần cha mẹ",
  Children:"Phụ kiện phụ",
  Level:"Hệ thống cấp bậc",
  Timing:"Thời gian",
  PieceCount:"sản phẩm",
  Wages:"Tiền lương",
  InternalProcess:"Quy trình nội bộ",
  ExternalProcess:"quá trình bên ngoài",
  ProceName:"Tên quy trình",
  ProceIndex:"Lệnh thực hiện",
  ChargeMan:"hiệu trưởng",
  BillMethod:"Phương thức thanh toán",
  ConsumTime:"giờ làm việc",
  Accessories:"Phụ kiện",
  Assembly:"Tập hợp",
  materials:"nguyên vật liệu",
  task:"Nhiệm vụ",
  process:"quá trình",
  BOM:"BOM",
  Production:"Sản xuất",
  RestorePurchaseOneUse:"Khôi phục giao dịch mua (một người dùng (giới hạn ở các giao dịch mua trước đó))",
  buy_fail_try_again:"Vui lòng click lại để mua hàng",
  Export:"Xuất khẩu",
  Date:"ngày",
  BankDetail:"thông tin chi tiết ngân hàng",
  Seller:"người bán",
  Buver:"người mua",
  Currency:"tiền tệ",
  CompanyName:"Tên công ty",
  ProformaInvoice:"hóa đơn chiếu lệ",
  Discount:"Giảm giá",
  PayStatus:"Tình trạng thanh toán",
  ShippingStatus:"Tình trạng giao hàng",
  FreightType:"Loại hình vận chuyển",
  Shipping:"vận chuyển hàng hóa",
  Payment:"Sự chi trả",
  Moneyname:"tên tiền tệ",
  Tax:"thuế",
  Freight:"Chi phí vận tải",
  Insurance:"bảo hiểm",
  Bankfee:"phí ngân hàng",
  Qc:"Chứng nhận chất lượng",
  Exchangerate:"tỷ giá",
  Shippingnumber:"số lô hàng",
  ShipDate:"Ngày xuất hàng",
  Arrivedate:"Ngày tới",
  Grossweight:"trọng lượng thô",
  CubicWeight:"trọng lượng khối",
  Totalpackages:"Tổng số gói",
  Moneytype:"loại tiền tệ",
  Quotedate:"Ngày trích dẫn",
  Validitydate:"Ngày hợp lệ",
  Paymentterm:"hết hạn trả lương",
  Priceterm:"thời hạn định giá",
  DeliveryTerm:"Thời gian giao hàng",
  BankName:"tên ngân hàng",
  BankAddress:"địa chỉ ngân hàng",
  SwiftCode:"Mã ngân hàng",
  Review:"Ôn tập",
  Signfor:"Ký nhận",
  Finance:"tài chính",
  Receiver:"Người nhận",
  Business:"việc kinh doanh",
  ContactPerson:"Người liên hệ",
  Profit:"lợi nhuận",
  Staff_must_use_in_browser_please_check_the_address_in_help_page:"Nhân viên phải sử dụng Google Chrome. Vui lòng kiểm tra địa chỉ IP trên trang trợ giúp của APP máy tính dịch vụ chính, sau đó nhập địa chỉ vào cột URL của các trình duyệt máy tính khác để mở thông tin đăng nhập",
  newPassword:"mật khẩu mới",
  ForgetPassword:"quên mật khẩu",
  ContactUs:"Liên hệ với chúng tôi/đưa ra đề xuất",
  Actualpay_should_big_then_shouldpay:"Khoản thu thực tế không thể lớn hơn khoản phải thu",
  ShopAddress:"Địa chỉ cửa hàng của tôi Quét mã QR để đặt hàng",
  Submit:"nộp",
  All:"tất cả",
  OrdernumExists:"Số đơn đặt hàng đã tồn tại",
  PermissionDenied:"sự cho phép bị từ chối",
  StockTransfer:"Chuyển nhượng chứng khoán",
  FromWarehouse:"Chuyển ra khỏi kho",
  ToWarehouse:"Chuyển về kho",
  PleaseUseInWebBrowser:"Vui lòng sử dụng chức năng xuất Excel trong Google Chrome",
  PleasePrintInWebBrowser:"Vui lòng sử dụng chức năng in trong Google Chrome",
  HistoryPrice:"giá lịch sử",
  SerialNumber:"số seri",
  Please_Use_In_APP:"Vui lòng sử dụng nó trong phần mềm máy tính",
  Please_Purchase_In_APP:"Vui lòng mua trong APP, không phải trong trình duyệt",
  Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Bạn có thể kết nối với cơ sở dữ liệu Postgresql. Dữ liệu của bạn sẽ được lưu trữ trong cơ sở dữ liệu Postgresql. Theo mặc định, bạn không cần kết nối với cơ sở dữ liệu Postgresql. Mặc định là cơ sở dữ liệu Sqlite cục bộ.",
  Connect_Postgresql_database_data_will_store_in_Postgresql:"Kết nối với cơ sở dữ liệu Postgresql, dữ liệu của bạn sẽ được lưu trữ trong cơ sở dữ liệu Postgresql và dữ liệu sẽ được đọc lại",
  Use_sqlite_data_will_store_in_local:"Sử dụng sqlite, dữ liệu sẽ được lưu trữ trên máy cục bộ",
  UsePostgresqlDatabase:"Sử dụng cơ sở dữ liệu PGSQL",
  UseSqliteDatabase:"Sử dụng cơ sở dữ liệu Sqlite",
  DatabaseName:"Cơ sở dữ liệu tên",
  Test_connect:"kiểm tra kết nối",
  If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Nếu sản phẩm có màu sắc, kích thước vui lòng điền số 0 cho kho ban đầu, sau khi thêm sản phẩm thì nhập kho trong giao dịch mua.",
  my:"của tôi",
  my_shop_qrcode_scan:"Mã QR của cửa hàng tôi cung cấp cho khách hàng khả năng quét mã để đặt hàng, điện thoại di động của khách hàng phải được kết nối với cùng một bộ định tuyến với máy tính của bạn.",
  ip:"IP",
  port:"Hải cảng",
  orderstatus:"Tình trạng đặt hàng",
  image:"hình ảnh",
  Template:"bản mẫu",
  Please_select_a_excel_file:"Vui lòng chọn một tập tin",
  Please_select_only_one_excel_file:"Chỉ có thể chọn một tập tin",
  Connect_Internet_Login_again:"Kết nối Internet và đăng nhập lại trước khi mua",

    productHasValidDate:'Sản phẩm có thời hạn hiệu lực',
productHasColor:'Sản phẩm có kích thước màu',
GeneralGoods:'Hàng tổng hợp',
Selected:'Đã chọn',
RestorePurchase:'Tiếp tục mua hàng',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Mua hóa đơn vĩnh viễn cho người dùng Phiên bản doanh nghiệp 1',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'Mua hóa đơn phiên bản doanh nghiệp là không giới hạn cho người dùng và thiết bị',
Purchasing:'Mua ... Hãy kiên nhẫn chờ đợi ...',
Validdate:'Thời hạn hiệu lực',
Makedate:'Ngày sản xuất',
Batch:'Mẻ',
CheckVersion:'Kiểm tra phiên bản',
Please_set_this_ip_address_on_App:'Vui lòng đặt địa chỉ IP hoặc địa chỉ IP này của máy tính trên APP.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Mở kết nối này trong máy tính hoặc trình duyệt di động của bạn (kết nối cùng một WiFi)',

    CheckVersion:'Kiểm tra phiên bản',
You_need_to_purchase:'Bạn chưa mua, vui lòng thêm WeChat vào Elink9988 E-mail:bvbuy@qq.com',
Thank_for_your_purchase:'Bạn đã mua',
New_version_available:'Có phiên bản mới',
Is_the_latest_version:'là phiên bản mới nhất',
    please:'xin vui lòng',
input:'đầu vào',
wrong:'sai rồi',
Verifycode:'Xác minh mã',
Upload:'Tải lên',
Download:'Tải về',
You_need_to_purchase_to_continue_use:'Bạn cần mua để tiếp tục sử dụng',
CheckBuy:'Kiểm tra mua hàng',
Exists:'Tồn tại',
NetworkUnavailable:'không có mạng',
Today:'Hôm nay',
Yesterday:'Hôm qua',
ThisMonth:'Tháng này',
LastMonth:'Tháng trước',
nickname:'tên nick',
storeName:'tên cửa hàng',
BuyStandAlone:'mua phiên bản độc lập',
PermissionDenied:'Quyền bị từ chối',
Boss:'Trùm',

    login:'Đăng nhập',
    operate:'Vận hành',
    register:'Đăng ký',
    username:'Tên người dùng',
    password:'Mật khẩu',
    User:'Người dùng',
    ok:'Được rồi',
    back:'Quay lại',
    success:'Thành công',
    fail:'Thất bại',
    cancel:'Hủy bỏ',
    add:'Thêm',
    edit:'Chỉnh sửa',
    delete:'Xóa',
    refresh:'Làm mới',
    close:'Đóng',
    cancel:'Hủy bỏ',
    return:'Trở về',
    ElinkInvoice:'Hóa đơn Elink',
    Purchase:'Mua hàng',
    BaseData:'BaseData',
    Sell:'Bán',
    PurchaseReturns:'Lợi nhuận mua hàng',
    SellReturns:'Bán trả lại',
    Inventory:'Hàng tồn kho',
    Statistics:'Thống kê',
    Receivable:'Phải thu',
    Payable:'Phải trả',
    Orders:'Đơn đặt hàng',
    StockTransfer:'Chuyển nhượng cổ phiếu',
    StockRecall:'Thu hồi cổ phiếu',
    Customer:'Khách hàng',
    Supplier:'Nhà cung cấp',
    Warehouse:'Kho',
    Color:'Màu',
    Size:'Kích thước',
    Category:'Thể loại',
    Category2:'Loại 2',
    Product:'Sản phẩm',
    Account:'Tài khoản',
    AccountType:'Danh mục tài khoản',
    Staff:'Nhân viên',
    typeone:'Thể loại',
    typetwo:'Tiểu thể loại',
    ProductName:'Tên sản phẩm',
    Specification:'Đặc điểm kỹ thuật',
    Barcode:'Mã vạch',
    Buyprice:'Mua giá',
    Sellprice:'Giá bán',
    Wholesaleprice:'Giá sỉ',
    Currentstock:'Dòng điện',
    Unit:'Đơn vị',
    Initstock:'Cổ phiếu ban đầu',
    Parameter:'Thông số',
    Remark:'Ghi chú',
    Supplier:'Nhà cung cấp',
    Customer:'Khách hàng',
    Staff:'Nhân viên',
    Receivable:'Phải thu',
    payable:'Phải trả',
    Receipts:'Biên lai',
    Paid:'Trả tiền',
    Preferential:'Ưu tiên',
    DateDay:'Ngày',
    OrderNum:'Số thứ tự',
    Name:'Tên',
    UserName:'Tên người dùng',
    IdNum:'Số ID',
    BirthDay:'Sinh nhật',
    SEX:'Giới tính',
    Female:'Nữ',
    Male:'Nam',
    Select:'Chọn',
    Address:'Địa chỉ',
    Phone:'Điện thoại',
    Email:'Email',
    CardNum:'Số thẻ',
    Price:'Giá',
    QTY:'Số lượng',
    SupplierCategory:'Danh mục nhà cung cấp',
    CustomerCategory:'Danh mục khách hàng',
    Power:'Sức mạnh',
    Role:'Vai trò',
    save:'Lưu lại',
    image:'Hình ảnh',
    search:'Tìm kiếm',
    Year:'Năm',
    Month:'Tháng',
    Day:'Ngày',
    Total:'Tổng cộng',
    WorkReport:'Báo cáo công việc',
    Leave:'Rời đi',
    CheckIn:'Đăng nhập',
    Announcement:'Thông báo',
    Approval:'Phê duyệt',
    Tracking:'Theo dõi',
    Bill:'Hóa đơn',
    OrdersDetail:'Chi tiết đơn hàng',
    Expense:'Chi phí',
    Income:'Thu nhập',
    Userfor:'Người dùng',
    Amount:'Số tiền',
    Title:'Tiêu đề',
    News:'Tin tức',
    SelectFile:'Chọn tệp',
    Content:'Nội dung',
    Cost:'Chi phí',
    ApprovalUser:'Người dùng chấp thuận',
    ApprovalStatus:'Tình trạng phê duyệt',
    ApprovalRemark:'Nhận xét phê duyệt',
    ApprovalDate:'Ngày phê duyệt',
    SubmitDate:'Ngày gửi',
    Status:'Tình trạng',
    FromDateTime:'Từ ngày',
    ToDateTime:'Đến ngày giờ',
    Subject:'Môn học',
    Latitude:'Vĩ độ',
    Longitude:'Kinh độ',
    Print:'In',
    DataTrans:'DataTrans',
    OA:'Viêm khớp',
    Setting:'Cài đặt',
    Help:'Giúp',
    ScanOpenInPhone:'Quét mở trong điện thoại',
    Building:'Tòa nhà',
    Room:'Phòng',
    HotelCheckIn:'Nhận phòng',
    CheckOut:'Kiểm tra',
    Hotel:'Khách sạn',
    Checkintime:'Kiểm tra trong thời gian',
    Checkouttime:'Giờ trả phòng',
    Deposit:'Gửi tiền',
    Cost:'Chi phí',
    RoomNum:'Phòng số',
    Rent:'Cho thuê',
    costday:'Ngày thường',
    rent:'Cho thuê',
    waternum:'Độ nước',
    electricnum:'Bằng điện',
    gasnum:'Độ khí',
    watercost:'Chi phí nước',
    electriccost:'Chi phí điện',
    gascost:'Chi phí gas',
    cleaningcost:'Chi phí vệ sinh',
    networkcost:'Chi phí mạng',
    tvcost:'Chi phí truyền hình',
    managecost:'Quản lý chi phí',
    othercost:'Chi phí khác',
    totalcost:'Tổng chi phí',
    remark:'Ghi chú',
    addtime:'Thêm giờ',
    OpenInBrowser:'Mở trong trình duyệt',
    InventoryProfit:'Lợi nhuận hàng tồn kho',
    InventoryLoss:'Mất hàng tồn kho',
    Buy:'Mua',
    Refresh:'Làm mới',
    Add:'Thêm',
    Search:'Tìm kiếm',
    Records:'bản ghi',

    }



// WEBPACK FOOTER //
// ./src/lang/vi-VN.js